<template>
  <div :class="['modal-container', { active: active }]">
    <div class="card head-card news" style="max-width: 50%; height: 60%">
      <div class="title-card">
        <h4>Vista previa</h4>
        <button class="touchpad" @click="close">x</button>
      </div>
      <div class="card-content">
        <div class="item">
          <div class="card noPadding">
            <div class="pdf-container">
              <iframe
                style="height: 580px;"
                zoom="120"
                :src="url"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ["close", "active","url"],
  data() {
    return {
      // o9P7NkbvmDWh5ZKeDHpeptYiZXN2/Newsletter.pdf
      link:"https://bdtr-newscast-bot.s3.amazonaws.com/newsletters/"
    };
  },
  mounted(){
    this.link += `${this.$store.state.userInfo.id}/Newsletter.pdf`;

    console.log(this.link,this.link);
  }
};
</script>
<style>
.pdf-container {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
iframe {
  width: 100%;
  border: none; /* Elimina el borde del iframe */
}
</style>